import React from "react";
import Selector from "canvas-core-react/lib/Selector";
import { useTranslation } from "react-i18next";

//id name value onChange placeholder
const BicDestinationBankSelect = ({ className = "", items = [], ...rest }) => {
  const { t } = useTranslation();

  return (
    <Selector
      className={className}
      placeholder={t("providers.manual.form.bicDestiny.placeholder")}
      label={t("general.provider_account_detail.destinatin_bic")}
      {...rest}
    >
      {items.map(({ bankName, idBankShort }, ind) => (
        <option key={`${idBankShort}-${ind}`} value={idBankShort}>
          {bankName}
        </option>
      ))}
    </Selector>
  );
};

export default BicDestinationBankSelect;
